var _rect, _path, _polygon, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVanTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.88,
    y: 26.5,
    width: 16.67,
    height: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,24.5V24s0-1.5,0-2.5c0-1.19-2.63-2-4.28-2.46-.56-.43-3.9-3-4.72-4.79-1.06-2.26-5-2.73-5.27-2.75H1.5V24.92a2.17,2.17,0,0,0,.42,1.33A3.06,3.06,0,0,0,4.5,27.47H5.82v-1H4.5a2.11,2.11,0,0,1-1.78-.82,1.23,1.23,0,0,1-.22-.73V24.5H8.12a2.75,2.75,0,1,0,2.26,0H32.12a2.75,2.75,0,1,0,2.26,0H38v1A1.09,1.09,0,0,1,37,26.56v1A2.09,2.09,0,0,0,39,25.5v-1ZM11,27a1.75,1.75,0,1,1-1.75-1.75A1.76,1.76,0,0,1,11,27Zm24,0a1.75,1.75,0,1,1-1.75-1.75A1.76,1.76,0,0,1,35,27ZM2.5,23.5v-11H24.68c1,.11,3.74.72,4.42,2.18,1,2.12,4.93,5.09,5.1,5.22l.18.09c1.76.44,3.49,1.17,3.62,1.51,0,.64,0,1.47,0,2Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "4 19.5 22.57 19.5 22.57 18.5 5 18.5 5 15 22.59 15 22.59 14 4 14 4 19.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,14H25v5.5h6.38l-1.8-3C28.08,14,27.73,14,27.5,14ZM26,18.5V15h1.34a12.89,12.89,0,0,1,1.38,2l.9,1.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanTooltip);
export default __webpack_public_path__ + "static/media/van_tooltip.1122f27b453040e7fba49ab6dd44bc28.svg";
export { ForwardRef as ReactComponent };